import React, { useState } from 'react';
import { useLocalization } from '../Context/MultiLanguageContext';

interface HeaderProps {
  userName: string;
  fetchUserProfile: () => void;
  handleLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ userName, fetchUserProfile, handleLogout }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { t } = useLocalization();

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <header className="relative flex items-center justify-between px-6 bg-white z-[1000]">
      <div>
      </div>
      <div className="flex items-center gap-6">
        <div className="relative m-3">
          <button
            onClick={toggleDropdown}
            className="relative border border-whitesmoke focus:outline-none flex rounded-full h-12 items-center px-2 gap-2"
          >
            <div className="w-8 h-8 overflow-hidden rounded-full">
              <img
                className="object-cover w-full h-full"
                src="https://cdn-icons-png.flaticon.com/128/18573/18573514.png"
                alt="User Avatar"
              />
            </div>
            <h1>{userName || 'Complete Profile'}</h1>
          </button>
          {dropdownOpen && (
            <>
              <div onClick={() => setDropdownOpen(false)} className="fixed inset-0 z-10 w-full h-full"></div>
              <div className="absolute right-0 z-20 w-52 h-24 p-2 border-2 mt-2 bg-white rounded-xl shadow-xl">
                <button
                  onClick={fetchUserProfile}
                  className="block w-full text-left px-4 py-2 rounded-xl text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                >
                   {t("profile")}
                </button>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 rounded-xl text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                >
                   {t("logout")}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
